import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';

import * as _ from 'lodash';
import ProductSelector from '@/components/productSelector/ProductSelector';
import { ProductDefinition, AnimationDefinition } from '@/models/configuratorx/configuratorSchema';
import Toggle from '@/components/parts/Toggle';

import PartsColor from '@/components/partsColor/PartsColor';



@Component({
  components: {
    toggle: Toggle,
    partsColor: PartsColor,
  },
})
export default class Misty9 extends Vue
{
  private _configuratorService: ConfiguratorService = undefined;


  @Inject()
  private _container: ComponentContainer;



  product: ProductDefinition;
  seletedGovdePlastik: string = MistyGovde.Beyaz;

  defHideObjects = [
    '_yyy',

  ];

  defShowObjects = [

    'misty3_beyaz_plastik_yyy',

  ];


  availableAnimations: AnimationDefinition[] = [];


  async created()
  {
    this.product = Store.getProductById('misty3');
    this.product.partsPalettes = _.orderBy(this.product.partsPalettes, ['order'], ['asc']);
    this.availableAnimations = this.product.animations as AnimationDefinition[];
    this.availableAnimationsChanged();
    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);
    await this._configuratorService.hideObjects({ objects: this.defHideObjects, operator: FilterOperators.Contains });
    await this._configuratorService.showObjects({ objects: this.defShowObjects, operator: FilterOperators.Contains });
    if (Store.state.selection)
    {
      Store.state.selection.parts.forEach((element) =>
      {
        this.colorChanged(element.color, element.palette, element.id);
      });
      await this.changeGovdePlastik(Store.state.selection.govdePlastik);

    } else
    {
      await this.applyDefaultSelection();
    }

  }

  availableAnimationsChanged()
  {

    this.$emit('availableAnimationsChanged', this.availableAnimations);
  }



  mounted()
  {
    // this.configuratorService = Store.state.configuratorService;

  }

  async applyDefaultSelection()
  {
    const selection = new MistySelection();
    selection.parts = [];
    selection.govdePlastik = MistyGovde.Beyaz;

    this.product.defaults.parts.forEach((element) =>
    {
      this.colorChanged(element.color, element.palette, element.id);
      const part = new PartSelection();
      part.id = element.id;
      part.color = element.color;
      part.palette = element.palette;
      part.name = element.name;
      selection.parts.push(part);
    });

    Store.state.selection = selection;

  }

  async changeGovdePlastik(govde: MistyGovde)
  {
    if (govde === MistyGovde.Beyaz)
    {
      await this._configuratorService.hideObjects({ objects: ['misty3_siyah_plastik_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['misty3_beyaz_plastik_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.govdePlastik = MistyGovde.Beyaz;
      this.seletedGovdePlastik = MistyGovde.Beyaz;

    }
    if (govde === MistyGovde.Siyah)
    {
      await this._configuratorService.hideObjects({ objects: ['misty3_beyaz_plastik_yyy'], operator: FilterOperators.Contains });
      await this._configuratorService.showObjects({ objects: ['misty3_siyah_plastik_yyy'], operator: FilterOperators.Contains });
      Store.state.selection.govdePlastik = MistyGovde.Siyah;
      this.seletedGovdePlastik = MistyGovde.Siyah;

    }

  }

  async colorChanged(color: any, palette: any, part: any)
  {

    const getPart = this.product.partsPalettes.find(x => x.part === part);
    const getPalettes = Store.state.configuratorConfig.definitions.palettes.find(x => x.id === palette);
    const getColor = getPalettes.colors.find(col => col.name === color);
    await this._configuratorService.changeAlbedoPBR({
      materials: getPart.materials,
      texture: getColor.texture,
    });
    Store.state.selection.parts.find(x => x.id === part).palette = palette;
    Store.state.selection.parts.find(x => x.id === part).color = color;
  }

}
export class MistySelection
{
  parts: PartSelection[];
  govdePlastik: MistyGovde;

}
export class PartSelection
{
  id: string;
  palette: string;
  color: string;
  name: string;
}

enum MistyGovde
{
  Beyaz = 'beyaz',
  Siyah = 'siyah',
}




// WEBPACK FOOTER //
// ./src/components/families/misty/Misty3.ts